"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.affiliationApi = void 0;
const createAffiliation = {
    method: "POST",
    url: "/affiliations",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const deleteAffiliations = {
    method: "DELETE",
    url: "/affiliations",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const getPaginatableAffiliations = {
    method: "GET",
    url: "/affiliations",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const getAffiliationsSummary = {
    method: "GET",
    url: "/affiliations/summary",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const getAffiliation = (affiliationId) => ({
    method: "GET",
    url: `/affiliations/${affiliationId}`,
    reducer: resp => resp,
    errReducer: resp => resp,
});
const updateAffiliation = (affiliationId) => ({
    method: "PUT",
    url: `/affiliations/${affiliationId}`,
    reducer: resp => resp,
    errReducer: resp => resp,
});
const checkIsAffiliationDuplicated = {
    method: "POST",
    url: "/affiliations/check-is-duplicated",
    reducer: resp => resp,
    errReducer: resp => resp,
};
exports.affiliationApi = {
    createAffiliation,
    deleteAffiliations,
    getAffiliation,
    getPaginatableAffiliations,
    getAffiliationsSummary,
    updateAffiliation,
    checkIsAffiliationDuplicated,
};
//# sourceMappingURL=affiliation.js.map